{
  "name": "PassCulture",
  "description": "Tu as 17 ou 18 ans ? Des livres aux concerts en passant par le cinéma et les festivals, le pass Culture te permet de profiter de toute la culture autour de chez toi !",
  "author": {
    "email": "support@passculture.app",
    "url": "https://pass.culture.fr",
    "name": "pass Culture",
    "twitter": "@pass_Culture"
  },
  "version": "1.395.0",
  "build": 10395000,
  "private": true,
  "engines": {
    "node": ">=25.9"
  },
  "homepage": ".",
  "scripts": {
    "preandroid": "./scripts/start_android_emulator_with_certificate.sh",
    "android": "yarn preandroid && react-native run-android",
    "android:prod": "yarn android --mode=productionDebug --appId=app.passculture.webapp",
    "android:staging": "yarn android --mode=stagingDebug --appId=app.passculture.staging",
    "android:testing": "yarn android --mode=apptestingDebug --appId=app.passculture.testing",
    "android:development": "yarn android --mode=developmentDebug --appId=app.passculture.testing",
    "build": "vite build",
    "build:development": "yarn build --mode=development",
    "build:integration": "yarn build --mode=integration",
    "build:production": "yarn build --mode=production",
    "build:staging": "yarn build --mode=staging",
    "build:testing": "yarn build --mode=testing",
    "build:perf": "yarn build --mode=perf",
    "build-storybook": "NODE_OPTIONS=--openssl-legacy-provider storybook build",
    "chromatic": "chromatic --exit-zero-on-changes --exit-once-uploaded",
    "fix:lint": "eslint . --ext .js,.ts,.tsx,.mjs --fix --quiet",
    "generate:api:client": "SWAGGER_CODEGEN_CLI_VERSION=3.0.32 ./scripts/generate_api_client.sh",
    "generate:api:client:silicon": "SWAGGER_CODEGEN_CLI_VERSION=3.0.32 ./scripts/generate_api_client_silicon.sh",
    "hotupdater:console": "NODE_ENV=testing yarn hot-updater console",
    "hotupdater:deploy:ios:testing": "NODE_ENV=testing yarn hot-updater deploy -p ios",
    "hotupdater:deploy:android:testing": "NODE_ENV=testing yarn hot-updater deploy -p android",
    "preios": "./scripts/check_xcode_version.sh",
    "ios": "yarn preios && CC=\"$(xcrun --find clang)\" CXX=\"$(xcrun --find clang++)\" react-native run-ios \"$@\" && yarn postios",
    "postios": "./scripts/add_certificate_to_ios_simulator.sh",
    "ios:prod": "yarn ios --scheme PassCulture-Production",
    "ios:staging": "yarn ios --scheme PassCulture-Staging",
    "ios:testing": "yarn ios --scheme PassCulture-Testing",
    "postinstall": "patch-package && jetify",
    "start": "react-native start",
    "start:web": "vite",
    "start:web:development": "yarn start:web --mode=development",
    "start:web:integration": "yarn start:web --mode=integration",
    "start:web:production": "yarn start:web --mode=production",
    "start:web:staging": "yarn start:web --mode=staging",
    "start:web:testing": "yarn start:web --mode=testing",
    "storybook": "NODE_OPTIONS='--openssl-legacy-provider' TZ=UTC storybook dev -p 6006",
    "test": "yarn test:lint && yarn test:types && yarn test:unit && yarn test:unit:web",
    "test:deadcode": "yarn knip --include-libs && NODE_ENV=production yarn knip --production --include-libs",
    "test:e2e:android:staging": "./scripts/run_e2e_tests.sh test android staging",
    "test:e2e:ios:staging": "./scripts/run_e2e_tests.sh test ios staging",
    "test:e2e:web:staging": "./scripts/run_e2e_tests.sh test web staging",
    "test:e2e:android:staging:cloud": "./scripts/run_e2e_tests.sh cloud android staging",
    "test:e2e:ios:staging:cloud": "./scripts/run_e2e_tests.sh cloud ios staging",
    "test:e2e:android:testing": "./scripts/run_e2e_tests.sh test android testing",
    "test:e2e:ios:testing": "./scripts/run_e2e_tests.sh test ios testing",
    "test:e2e:web:testing": "./scripts/run_e2e_tests.sh test web testing",
    "test:e2e:android:testing:cloud": "./scripts/run_e2e_tests.sh cloud android testing",
    "test:e2e:ios:testing:cloud": "./scripts/run_e2e_tests.sh cloud ios testing",
    "test:lint": "eslint . --ext .js,.ts,.tsx,.mjs --cache --quiet",
    "test:lint:count": "./scripts/eslint-warnings.sh",
    "test:lint:archi": "ESLINT_SCOPE=archi eslint . --ext .js,.ts,.tsx,.mjs --cache",
    "test:lint:cleancode": "ESLINT_SCOPE=cleancode eslint . --ext .js,.ts,.tsx,.mjs --cache",
    "test:lint:changed": "./scripts/lint_changed.sh",
    "test:storybook:accessibility": "TZ=UTC axe-storybook --storybook-address http://localhost:6006",
    "test:types": "tsc",
    "test:unit": "TZ=UTC JEST=true node --no-compilation-cache --expose-gc ./node_modules/.bin/jest --forceExit --logHeapUsage",
    "test:unit:ci": "JEST_SILENT_REPORTER_DOTS=true yarn test:unit --maxWorkers=6 --coverage --ci --reporters=jest-junit --reporters=jest-silent-reporter",
    "test:unit:full": "TZ=UTC JEST=true jest --collect-coverage",
    "test:unit:web": "TZ=UTC JEST=true node --no-compilation-cache --expose-gc ./node_modules/.bin/jest --config jest.web.config.js --forceExit --logHeapUsage",
    "test:unit:web:ci": "yarn test:unit:web --maxWorkers=6 --coverage --ci --reporters=jest-junit --reporters=jest-silent-reporter",
    "add:tracker": "python3 scripts/add_tracker.py",
    "trigger:production:deploy": "./scripts/deploy_new_production_version.sh",
    "trigger:staging:deploy": "./scripts/release_staging_minor.sh && ./scripts/deploy_new_version.sh testing/v minor",
    "trigger:staging:deploy:patch": "./scripts/deploy_new_version.sh patch/v patch",
    "trigger:testing:deploy": "./scripts/deploy_new_version.sh testing/v patch",
    "update:tools": "nix flake update && git commit --only flake.lock --message '(BSR) chore(deps): update tools'",
    "prepare": "husky"
  },
  "dependencies": {
    "@bam.tech/react-native-config": "^1.4.5",
    "@batch.com/react-native-plugin": "10.1.2",
    "@d11/react-native-fast-image": "^8.13.0",
    "@emotion/is-prop-valid": "^1.3.1",
    "@gorhom/bottom-sheet": "^5.2.6",
    "@hookform/resolvers": "^2.9.11",
    "@hot-updater/react-native": "^0.20.11",
    "@invertase/react-native-apple-authentication": "^2.5.1",
    "@openspacelabs/react-native-zoomable-view": "^2.1.5",
    "@pass-culture/design-system": "0.9.2",
    "@ptomasroos/react-native-multi-slider": "^2.2.2",
    "@react-native-async-storage/async-storage": "^1.17.11",
    "@react-native-clipboard/clipboard": "^1.16.2",
    "@react-native-community/blur": "^4.4.1",
    "@react-native-community/netinfo": "^11.4.1",
    "@react-native-firebase/analytics": "^22.2.1",
    "@react-native-firebase/app": "^22.2.1",
    "@react-native-firebase/firestore": "^22.2.1",
    "@react-native-firebase/perf": "^22.2.1",
    "@react-native-firebase/remote-config": "^22.2.1",
    "@react-native-google-signin/google-signin": "^10.1.0",
    "@react-navigation/bottom-tabs": "^7.15.9",
    "@react-navigation/devtools": "^7.0.40",
    "@react-navigation/native": "^7.2.2",
    "@react-navigation/native-stack": "^7.14.11",
    "@react-oauth/google": "^0.13.4",
    "@sentry/react": "^8.55.0",
    "@sentry/react-native": "^6.22.0",
    "@sentry/types": "^8.55.0",
    "@shopify/flash-list": "^2.0.2",
    "@storybook/testing-library": "^0.2.2",
    "@tanstack/query-async-storage-persister": "^5.90.1",
    "@tanstack/react-query": "5.87.1",
    "@tanstack/react-query-persist-client": "^5.90.1",
    "@zootools/email-spell-checker": "^1.11.0",
    "algoliasearch": "^5.45.0",
    "chromatic": "^11.27.0",
    "color-alpha": "^1.1.3",
    "contentful-resolve-response": "^1.3.0",
    "date-fns": "^2.29.1",
    "date-fns-tz": "^2.0.0",
    "firebase": "^10.9.0",
    "geojson": "^0.5.0",
    "globalthis": "^1.0.2",
    "highlight-words-core": "^1.2.2",
    "instantsearch.js": "^4.74.2",
    "intl": "^1.2.5",
    "jwt-decode": "^3.1.2",
    "libphonenumber-js": "^1.12.6",
    "lodash": "^4.17.23",
    "lottie-react-native": "^7.3.2",
    "patch-package": "^8.0.0",
    "react": "19.1.0",
    "react-app-polyfill": "^2.0.0",
    "react-device-detect": "^2.2.3",
    "react-dom": "19.1.0",
    "react-error-boundary": "^3.1.0",
    "react-helmet": "^6.1.0",
    "react-hook-form": "^7.35.0",
    "react-instantsearch-core": "^7.20.0",
    "react-mobile-picker": "^0.2.1",
    "react-native": "0.80.2",
    "react-native-adjust": "^5.5.0",
    "react-native-animatable": "^1.3.3",
    "react-native-calendars": "1.1312.0",
    "react-native-date-picker": "^5.0.13",
    "react-native-device-info": "^14.0.4",
    "react-native-email-link": "^1.10.0",
    "react-native-geolocation-service": "5.3.1",
    "react-native-gesture-handler": "^2.29.1",
    "react-native-get-random-values": "^1.5.1",
    "react-native-in-app-review": "^4.3.1",
    "react-native-intersection-observer": "^0.2.1",
    "react-native-keychain": "^10.0.0",
    "react-native-linear-gradient": "^2.8.3",
    "react-native-lottie-splash-screen": "^1.1.2",
    "react-native-map-clustering": "^4.0.0",
    "react-native-map-link": "^3.10.1",
    "react-native-maps": "1.24.2",
    "react-native-modal": "13.0.1",
    "react-native-orientation-locker": "^1.7.0",
    "react-native-performance": "^5.1.4",
    "react-native-permissions": "^5.4.1",
    "react-native-qrcode-svg": "^6.1.2",
    "react-native-reanimated": "patch:react-native-reanimated@npm%3A4.1.7#~/.yarn/patches/react-native-reanimated-npm-4.1.7-30a13d0d8a.patch",
    "react-native-reanimated-carousel": "^4.0.2",
    "react-native-safe-area-context": "^5.5.1",
    "react-native-screens": "^4.11.1",
    "react-native-share": "^12.2.1",
    "react-native-svg": "^15.12.1",
    "react-native-url-polyfill": "^1.3.0",
    "react-native-web": "^0.19.13",
    "react-native-web-lottie": "^1.4.4",
    "react-native-web-swiper": "2.2.4",
    "react-native-webview": "^13.15.0",
    "react-native-worklets": "^0.6.1",
    "react-native-youtube-iframe": "^2.3.0",
    "react-window": "^1.8.9",
    "react-youtube": "^10.1.0",
    "reset-css": "^5.0.2",
    "resize-observer-polyfill": "^1.5.1",
    "search-insights": "^2.13.0",
    "styled-components": "^6.1.19",
    "supercluster": "^8.0.1",
    "uuid": "^14.0.0",
    "yup": "^0.32.11",
    "zustand": "^4.5.7"
  },
  "devDependencies": {
    "@babel/core": "^7.25.2",
    "@babel/eslint-parser": "^7.24.1",
    "@babel/plugin-proposal-export-default-from": "^7.24.1",
    "@babel/plugin-proposal-export-namespace-from": "^7.18.9",
    "@babel/plugin-proposal-unicode-property-regex": "^7.18.6",
    "@babel/plugin-transform-numeric-separator": "^7.24.1",
    "@babel/plugin-transform-react-jsx-source": "^7.24.1",
    "@babel/preset-env": "^7.25.3",
    "@babel/preset-react": "^7.24.1",
    "@babel/preset-typescript": "^7.24.1",
    "@babel/runtime": "^7.26.10",
    "@bam.tech/eslint-plugin": "^1.0.1",
    "@chanzuckerberg/axe-storybook-testing": "^10.0.0",
    "@chromatic-com/storybook": "^5.1.2",
    "@hot-updater/bare": "^0.20.11",
    "@hot-updater/firebase": "^0.20.11",
    "@hot-updater/sentry-plugin": "^0.20.11",
    "@react-native-community/cli": "19.1.2",
    "@react-native-community/cli-platform-android": "19.1.2",
    "@react-native-community/cli-platform-ios": "19.1.2",
    "@react-native/babel-preset": "0.80.2",
    "@react-native/eslint-config": "0.80.2",
    "@react-native/metro-config": "0.80.2",
    "@react-native/typescript-config": "0.80.2",
    "@rollup/plugin-commonjs": "^29.0.2",
    "@sentry/vite-plugin": "^5.1.1",
    "@storybook/addon-a11y": "^10.3.5",
    "@storybook/addon-docs": "^10.3.5",
    "@storybook/addon-links": "^10.3.5",
    "@storybook/react-native-web-vite": "^10.3.5",
    "@storybook/react-vite": "^10.3.5",
    "@testing-library/jest-dom": "^6.6.4",
    "@testing-library/jest-native": "^5.4.3",
    "@testing-library/react": "^16.3.0",
    "@testing-library/react-native": "^13.3.3",
    "@testing-library/user-event": "^14.6.1",
    "@tsconfig/react-native": "^3.0.0",
    "@types/contentful-resolve-response": "^0.1.30",
    "@types/geojson": "^7946.0.7",
    "@types/globalthis": "^1.0.1",
    "@types/google.accounts": "^0.0.18",
    "@types/highlight-words-core": "^1.2.0",
    "@types/jest": "^29.5.13",
    "@types/jest-axe": "^3.5.9",
    "@types/lodash": "^4.14.182",
    "@types/node": "18",
    "@types/react": "19.1.0",
    "@types/react-dom": "19.1.0",
    "@types/react-helmet": "^6.1.2",
    "@types/react-native-calendars": "^1.1264.3",
    "@types/react-test-renderer": "^19.1.0",
    "@types/react-window": "^1.8.6",
    "@types/supercluster": "^7.1.3",
    "@typescript-eslint/eslint-plugin": "^5.38.0",
    "@typescript-eslint/parser": "^5.62.0",
    "@vitejs/plugin-react": "^6.0.1",
    "@welldone-software/why-did-you-render": "^7.0.1",
    "babel-jest": "^30.0.5",
    "babel-loader": "^8.2.5",
    "babel-plugin-macros": "^3.1.0",
    "babel-plugin-module-resolver": "^4.0.0",
    "babel-plugin-named-asset-import": "^0.3.8",
    "babel-plugin-polyfill-corejs2": "^0.4.11",
    "babel-plugin-polyfill-regenerator": "^0.3.1",
    "babel-plugin-react-compiler": "^19.1.0-rc.3",
    "babel-plugin-react-native-web": "^0.18.7",
    "babel-plugin-styled-components": "^2.1.4",
    "babel-preset-react-app": "^10.0.1",
    "cross-fetch": "^3.1.5",
    "danger": "^13.0.5",
    "deepmerge": "^4.2.2",
    "dotenv": "^8.2.0",
    "dotenv-expand": "^5.1.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-import-resolver-alias": "^1.1.2",
    "eslint-plugin-boundaries": "^5.0.1",
    "eslint-plugin-header": "^3.1.1",
    "eslint-plugin-import": "^2.22.1",
    "eslint-plugin-jest": "^27.1.4",
    "eslint-plugin-jest-formatting": "^3.1.0",
    "eslint-plugin-local-rules": "^1.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-react": "^7.33.2",
    "eslint-plugin-react-hooks": "^7.0.0",
    "eslint-plugin-react-native": "^3.8.1",
    "eslint-plugin-sort-keys-fix": "^1.1.2",
    "eslint-plugin-storybook": "10.3.5",
    "eslint-plugin-testing-library": "^6.2.0",
    "eslint-plugin-typescript-sort-keys": "^2.3.0",
    "eslint-plugin-unused-imports": "^3.0.0",
    "firebase-admin": "^13.4.0",
    "firebase-tools": "^15.12.0",
    "hot-updater": "^0.20.11",
    "husky": "^9.1.7",
    "jest": "^30.0.5",
    "jest-axe": "^9.0.0",
    "jest-canvas-mock": "^2.3.1",
    "jest-environment-jsdom": "^29.6.2",
    "jest-fixed-jsdom": "0.0.9",
    "jest-junit": "^13.2.0",
    "jest-silent-reporter": "^0.6.0",
    "jest-styled-components": "^7.0.8",
    "jetifier": "^1.6.5",
    "json": "^11.0.0",
    "knip": "^5.43.6",
    "mockdate": "^3.0.2",
    "msw": "^2.7.3",
    "prettier": "^3.5.3",
    "react-native-svg-web": "^1.0.9",
    "react-native-web-linear-gradient": "^1.1.2",
    "react-test-renderer": "19.1.0",
    "storybook": "^10.3.5",
    "timezone-mock": "^1.2.1",
    "ts-node": "^10.8.0",
    "type-fest": "^4.15.0",
    "typescript": "5.0.4",
    "vite": "8.0.5",
    "vite-bundle-analyzer": "^1.3.6",
    "vite-plugin-html": "^3.2.2"
  },
  "resolutions": {
    "@ai-sdk/gateway@< 3.0.0": "3.0.120",
    "@ai-sdk/provider@< 3.0.0": "3.0.10",
    "@ai-sdk/provider-utils@<= 3.0.97": "4.0.27",
    "ai@^5.0.18": "6.0.191",
    "@babel/plugin-syntax-typescript": "^7.23.3",
    "@babel/plugin-transform-modules-systemjs": "^7.29.4",
    "@babel/plugin-transform-typescript": "^7.23.6",
    "@babel/preset-typescript": "^7.23.3",
    "@babel/types": "^7.23.6",
    "@hono/node-server@< 1.19.13": "^1.19.13",
    "@protobufjs/utf8@<= 1.1.0": "^1.1.1",
    "@storybook/react-docgen-typescript-plugin": "1.0.6--canary.9.cd77847.0",
    "@tootallnate/once@< 3.0.1": "^3.0.1",
    "ansi-regex": "^5.0.1",
    "basic-ftp@= 5.2.0": "^5.2.1",
    "brace-expansion@< 1.1.13": "^1.1.13",
    "brace-expansion@>= 2.0.0, < 2.0.3": "^2.0.3",
    "color-name": "1.1.*",
    "cross-spawn": "^7.0.6",
    "fast-uri": "^3.1.2",
    "fast-xml-parser": "^5.0.0",
    "flatted@<= 3.4.1": "^3.4.2",
    "follow-redirects@<= 1.15.11": "^1.16.0",
    "glob-parent": "^5.1.2",
    "glob@>= 10.2.0, < 10.5.0": "^10.5.0",
    "hono@< 4.12.21": "^4.12.21",
    "ip-address@<= 10.1.0": "^10.1.1",
    "js-yaml@< 3.14.2": "^3.14.2",
    "js-yaml@>= 4.0.0, < 4.1.1": "^4.1.1",
    "json-schema": "^0.4.0",
    "json5": "^1.0.2",
    "jws@4.0.0": "^4.0.1",
    "jws@< 3.2.3": "^3.2.3",
    "loader-utils": "^2.0.0",
    "lodash-es@<= 4.17.23": "^4.18.0",
    "lodash@<= 4.17.23": "^4.18.0",
    "minimatch@>= 3.0.0, <3.1.4": "^3.1.4",
    "minimatch@>= 5.0.0, <5.1.8": "^5.1.8",
    "minimatch@>= 6.0.0, <6.2.2": "^6.2.2",
    "minimatch@>= 9.0.0, <9.0.7": "^9.0.7",
    "node-forge@<= 1.3.3": "^1.4.0",
    "nth-check": "^2.0.1",
    "on-headers@< 1.1.0": "^1.1.0",
    "path-to-regexp@0.1.12": "^0.1.13",
    "path-to-regexp@>= 8.0.0, < 8.4.0": "^8.4.0",
    "picomatch@>= 2.0.0, <2.3.2": "^2.3.2",
    "picomatch@>= 4.0.0, <4.0.4": "^4.0.4",
    "playwright@< 1.55.1": "^1.55.1",
    "postcss@< 8.5.10": "^8.5.10",
    "protobufjs@< 7.5.5": "^7.5.5",
    "qs@< 6.14.1": "^6.14.1",
    "query-string": "^7.1.*",
    "react-is": "^19.0.0",
    "react-native-maps@1.24.2": "patch:react-native-maps@npm%3A1.24.2#./.yarn/patches/react-native-maps-npm-1.24.2-83a01f59cc.patch",
    "react-side-effect": "2.1.2",
    "semver": "^7.5.2",
    "serialize-javascript@<= 7.0.2": "^7.0.3",
    "simple-git": "3.32.3",
    "tar": "7.5.11",
    "tmp@<= 0.2.3": "^0.2.4",
    "tslib": "2.3.*",
    "undici": "6.24.1",
    "uuid": "^14.0.0",
    "yaml@>= 2.0.0, < 2.8.3": "^2.8.3"
  },
  "exports": {
    ".": "./index.js",
    "./jsx-dev-runtime": "./jsx-dev-runtime.js",
    "./jsx-runtime": "./jsx-runtime.js",
    "./": "./"
  },
  "packageManager": "yarn@4.15.0"
}
